export default {
  MAX_NUMBER_ZUSATZFOTOS: 3,
  MAX_NUMBER_ZUSATZDOKUMENTE: 3,
  SCOUT_LOCATION_LENGTH: 20,
  MAX_IMAGE_SIZE: 1920,
  MAX_TEXT_LENGTH: 400,
  MAX_WOHNUNGSNUMMER_TEXT_LENGTH: 50,
  ALLOWED_KEYS: ['Backspace', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Del'],
  JA_NEIN: [{label: 'Ja', value: true},{label: 'Nein', value: false}],
  IMAGE_MAP: {
    aussenwaende: {
      _foto_vorne_aussen: 'aussenansichtVorne',
      _foto_hinten_aussen: 'aussenansichtHinten',
      _foto_schaeden_aussen: 'offensichtlicheSchaeden',
      zusatzfoto: '_foto_zusatz_aussen',
    },
    dach: {
      _foto_aussen_dach: 'dacheindeckungAussen',
      _foto_innen_dach: 'dachgeschossInnen',
      _foto_schaeden_dach: 'offensichtlicheSchaeden',
      zusatzfoto: '_foto_zusatz_dach',
    },
    fenster: {
      _foto_tuer_roll: 'hauseingangstuer',
      _foto_fenster_roll: 'fenster',
      _foto_schaeden_roll: 'offensichtlicheSchaeden',
      zusatzfoto: '_foto_zusatz_roll',
    },
    fussboeden: {
      _foto_boden1_boden: 'fussboden1',
      _foto_boden2_boden: 'fussboden2',
      _foto_boden3_boden: 'fussboden3',
      _foto_schaeden_boden: 'offensichtlicheSchaeden',
      zusatzfoto: '_foto_zusatz_boden',
    },
    innenwaende: {
      _foto_tuer1_innen: 'innentuer1',
      _foto_tuer2_innen: 'innentuer2',
      _foto_wand1_innen: 'innenwand1',
      _foto_wand2_innen: 'innenwand2',
      _foto_wand3_innen: 'innenwand3',
      _foto_schaeden_innen: 'offensichtlicheSchaeden',
      zusatzfoto: '_foto_zusatz_innen',
    },
    decken: {
      _foto_treppe1_decke: 'treppe1',
      _foto_treppe2_decke: 'treppe2',
      _foto_decke1_decke: 'deckenkonstruktion1',
      _foto_decke2_decke: 'deckenkonstruktion2',
      _foto_schaeden_decke: 'offensichtlicheSchaeden',
      zusatzfoto: '_foto_zusatz_decke',
    },
    sanitaer: {
      _foto_bad1_bad: 'bad1',
      _foto_bad2_bad: 'bad2',
      _foto_schaeden_bad: 'offensichtlicheSchaeden',
      zusatzfoto: '_foto_zusatz_bad',
    },
    heizung: {
      _foto_heizung1_heizung: 'heizungsanlage1',
      _foto_heizung2_heizung: 'heizungsanlage2',
      _foto_schaeden_heizung: 'offensichtlicheSchaeden',
      zusatzfoto: '_foto_zusatz_heizung',
    },
    technischeAusstattung: {
      _foto_sicherung_sonst: 'sicherungskasten',
      _foto_stecklicht_sonst: 'steckdosen',
      _foto_schaeden_sonst: 'offensichtlicheSchaeden',
      zusatzfoto: '_foto_zusatz_sonst',
    },
    objektunterlagen: {
      _grundriss_unterlagen: 'grundriss',
      _grundriss_zusatz_unterlagen: 'zusatzdokumentGrundriss',
      _grundriss_energieausweis: 'energieausweis',
      _grundriss_zusatz_energieausweis: 'zusatzdokumentEnergieausweis',
    },
  },
  KPA_DOKUMENT_MAP: {
    _unterlagen_grundbuchauszug: 'grundbuchauszug',
    _unterlagen_kaufvertrag: 'kaufvertrag',
    _unterlagen_grundriss: 'grundriss',
    _unterlagen_mietvertraege: 'mietvertraege',
    _unterlagen_energieausweis: 'energieausweis',
    _unterlagen_bauunterlagen: 'bauunterlagen',
    _unterlagen_teilungserklaerung: 'teilungserklaerung',
  }
};
